import React from "react";
import { Clock, Bookmark } from "lucide-react";
import {
  getQuestionType,
  estimateSeconds,
} from "../../pages/UserTest/testUtils";
import RatingQuestion from "../RatingQuestion/RatingQuestion";
import SingleChoiceQuestion from "./SingleChoiceQuestion";
import MultipleChoiceQuestion from "./MultipleChoiceQuestion";

const TYPE_LABEL = {
  RATING: "Rating",
  SINGLE_CHOICE: "Single choice",
  MULTIPLE_CHOICE: "Multiple choice",
};

const TYPE_CLASS = {
  RATING: "type-rating",
  SINGLE_CHOICE: "type-single",
  MULTIPLE_CHOICE: "type-multi",
};

/**
 * QuestionCard
 * The premium "container" every question renders inside: number, type
 * badge, estimated time, bookmark toggle, question text, then the answer
 * widget appropriate to the detected question type.
 */
const QuestionCard = ({
  question,
  questionNumber,
  singleAnswer,
  multiAnswer,
  onSelectSingle,
  onToggleMulti,
  isBookmarked,
  onToggleBookmark,
}) => {
  const type = getQuestionType(question);
  const seconds = estimateSeconds(type);

  return (
    <div className="question-card">
      <div className="qc-header">
        <div className="qc-meta-row">
          <span className={`qc-badge ${TYPE_CLASS[type]}`}>
            {TYPE_LABEL[type]}
          </span>
          <span className="qc-number">Question {questionNumber}</span>
          <span className="qc-time">
            <Clock /> ~{seconds}s
          </span>
        </div>

        <button
          type="button"
          className={`qc-bookmark-btn ${isBookmarked ? "active" : ""}`}
          aria-label={
            isBookmarked ? "Remove bookmark" : "Bookmark this question"
          }
          onClick={onToggleBookmark}
        >
          <Bookmark />
        </button>
      </div>

      <h3 className="qc-text">{question.questionText}</h3>

      {type === "RATING" && (
        <RatingQuestion
          question={question}
          selectedOptionId={singleAnswer}
          onSelect={onSelectSingle}
        />
      )}

      {type === "SINGLE_CHOICE" && (
        <SingleChoiceQuestion
          question={question}
          selectedOptionId={singleAnswer}
          onSelect={onSelectSingle}
        />
      )}

      {type === "MULTIPLE_CHOICE" && (
        <MultipleChoiceQuestion
          question={question}
          selectedOptionIds={multiAnswer}
          onToggle={onToggleMulti}
        />
      )}
    </div>
  );
};

export default QuestionCard;
